import CustomersEditTabs from './CustomersEditTabs';

export default CustomersEditTabs;
